/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RestrictedActionTypes } from 'src/types/AppNotifications';

export interface GlobalAppState {
  restrictedAction?: RestrictedActionTypes,
  showMarketplaceBanner: boolean,
}

export const initialState: GlobalAppState = {
  showMarketplaceBanner: false,
};

export const appNotificationsSlice = createSlice({
  name: 'appNotifications',
  initialState,
  reducers: {
    setRestrictedAction: (
      state: GlobalAppState,
      action: PayloadAction<RestrictedActionTypes | undefined>,
    ) => {
      state.restrictedAction = action.payload;
    },
    setShowMarketplaceBanner: (
      state: GlobalAppState,
      action: PayloadAction<boolean>,
    ) => {
      state.showMarketplaceBanner = action.payload;
    },
  },
});

export const {
  setRestrictedAction,
  setShowMarketplaceBanner,
} = appNotificationsSlice.actions;

export default appNotificationsSlice.reducer;
